import {Decision} from '../api/Decision';
import {ExComissionSeance} from './ex-comission-seance';

export class ExDecision extends Decision {
    public labelDecision = '';

    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
            if (this.commissionSeance != null && this.commissionSeance !== '') {
                this.commissionSeance = new ExComissionSeance(
                    this.commissionSeance
                );
            }

            this.setDecision();
        }
    }

    // const DECISION_VIDE = 0;
    //   const DECISION_ACCEPTE = 1;
    //   const DECISION_REFUSE = 2;
    //   const DECISION_LISTE_COMPLEMENTAIRE = 3;
    //   const DECISION_LISTE_COMPLEMENTAIRE_REMONTE = 4;
    //   const DECISION_LISTE_ATTENTE = 5;
    //   const DECISION_AUTRE = 6;

    public setDecision() {
        switch (+this.decision) {
            case 0:
                this.labelDecision = '';
                break;
            case 1:
                this.labelDecision = 'Accepté';
                break;
            case 2:
                this.labelDecision = 'Non retenu';
                break;
            case 3:
                this.labelDecision = 'Liste complémentaire';
                break;
            case 4:
                this.labelDecision = 'Liste complémentaire remonté';
                break;
            case 5:
                this.labelDecision = 'Liste d\'attente';
                break;
            case 6:
                this.labelDecision = 'Autre';
                break;
        }
    }
}
